<label [for]="name()" class="flex gap-2">
  <div class="grid place-items-center">
    <input
      class="border-theme-primary-blue peer col-start-1 row-start-1 aspect-square w-5 cursor-pointer appearance-none rounded-full border-2"
      type="radio"
      [checked]="checked()"
      [id]="name()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      (click)="value.set(this.radioButtonValue())" />

    <div
      class="peer-checked:bg-theme-primary-blue pointer-events-none col-start-1 row-start-1 aspect-square w-2.5 rounded-full"></div>
  </div>

  @if (label()) {
    @if (!labelTemplate()) {
      <button (click)="value.set(this.radioButtonValue())">{{ label() }}</button>
    } @else {
      <ng-container
        [ngTemplateOutlet]="labelTemplate()"
        [ngTemplateOutletContext]="{ $implicit: label() }" />
    }
  }
</label>
